module.exports = __webpack_public_path__ + "static/logowa-7d35838d33cf7a3caa827cc51c920337.png";